module.exports = __webpack_public_path__ + "static/img/avatar-s-15.d50eb9cb.jpg";